import { QUERY_KEYS } from 'api/query-keys';
import { availabilityService } from 'api/services';
import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';

export const useGetWorkerAvailability = (
  workerId: string | null,
  fromDate: DateTime,
  toDate: DateTime
) => {
  const { site } = useSiteDetection();
  const transformedFromDate = fromDate.toISODate();
  const transformedToDate = toDate.toISODate();
  const query = useQuery({
    queryKey: QUERY_KEYS.workerAvailability(workerId ?? '', transformedFromDate),
    queryFn: async () =>
      await availabilityService.getWorkerAvailability(
        site,
        workerId,
        transformedFromDate,
        transformedToDate
      ),
    enabled: !!workerId,
  });
  return query;
};
